import React, { useContext, useState } from 'react'
import Calendar, {
  Select,
  Option,
} from '../../styles/calendar'
import { LocaleContext } from '../../routes'
import { getPersianNumber } from '../../utils/number'
import moment from 'jalali-moment'
import Button from './Button'
import { MAX_BIRTH_YEAR } from '../../utils/constants'

export default ({ onChange, hideCalendar }) => {
  const locale = useContext(LocaleContext)
  const [day, setDay] = useState()
  const [month, setMonth] = useState()
  const [year, setYear] = useState()

  const optionHeight = 40
  const selectCount = 5

  const submitDate = () => {
    const birthdate = moment.from(
      [year, month, day].join('/'),
      'fa',
      'YYYY/M/D'
    ).locale('en').format('YYYY/M/D')
    const birthdateValue = new Date(birthdate).getTime()
    onChange(birthdateValue)
    hideCalendar()
  }

  const daysRange = month <= 6 ? 31 : 30
  const days = Array(daysRange).fill().map((d, index) =>
    <Option
      key={index}
      value={index + 1}
      selected={day === index + 1}
      className={day === index + 1 ? 'selected' : ''}
      style={{ height: optionHeight }}
      onClick={e => {
        setDay(index + 1)
        e.target.parentElement.scrollTop = index * optionHeight - optionHeight
      }}>
      {getPersianNumber(index + 1)}
    </Option>
  )
  const months = locale.MONTHS.map((m, index) =>
    <Option
      key={index}
      value={index + 1}
      selected={month === index + 1}
      className={month === index + 1 ? 'selected' : ''}
      style={{ height: optionHeight }}
      onClick={e => {
        setMonth(index + 1)
        e.target.parentElement.scrollTop = index * optionHeight - optionHeight
      }}>
      {m}
    </Option>
  )
  const years = Array(MAX_BIRTH_YEAR - 1300).fill().map((y, index) =>
    <Option
      key={index}
      value={MAX_BIRTH_YEAR - index}
      selected={year === MAX_BIRTH_YEAR - index}
      className={year === MAX_BIRTH_YEAR - index ? 'selected' : ''}
      style={{ height: optionHeight }}
      onClick={e => {
        setYear(MAX_BIRTH_YEAR - index)
        e.target.parentElement.scrollTop = index * optionHeight - optionHeight
      }}>
      {getPersianNumber(MAX_BIRTH_YEAR - index)}
    </Option>
  )

  const getDateElementPosition = e => {
    e.stopPropagation()
    const isFirst = e.target.scrollTop === 0
    const isLast = e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop === 0
    const innerMargin = selectCount * optionHeight - e.target.clientHeight
    // console.log(e.target.scrollTop, isFirst, isLast);
    return Math.round((e.target.scrollTop - innerMargin) / optionHeight) + Math.floor(selectCount / 2) + Number(isLast) - Number(isFirst)
  }

  const scrollDay = e => setDay(getDateElementPosition(e))

  const scrollMonth = e => setMonth(getDateElementPosition(e))

  const scrollYear = e => setYear(MAX_BIRTH_YEAR - getDateElementPosition(e) + 1)

  return (
    <>
      <Calendar>
        <Select style={{ padding: `${optionHeight}px 0` }} onScroll={e => scrollDay(e)}>
          {days}
        </Select>
        <Select style={{ padding: `${optionHeight}px 0` }} onScroll={e => scrollMonth(e)}>
          {months}
        </Select>
        <Select style={{ padding: `${optionHeight}px 0` }} onScroll={e => scrollYear(e)}>
          {years}
        </Select>
      </Calendar>
      <Button onClick={submitDate}>{locale.SUBMIT}</Button>
    </>
  )
}